import { Button, Grid, Group, Modal, NativeSelect, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import useFetch from '../../helpers/useFetch';

const RecommenderCopyModal = ({ recommender: passedRecommender, show, save, close }) => {
  const { accountId, domainId } = useParams();
  const fetch = useFetch();
  const [pages, setPages] = useState();
  const [error, setError] = useState();
  const [recommender, setRecommender] = useState({
    ...passedRecommender,
    id: null,
    name: `${passedRecommender.name} Copy`,
  });

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pages`)
      .then(({ pages }) => {
        setPages(pages);
      })
      .catch(setError);
  }, [accountId, domainId, fetch]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  const submitForm = (e) => {
    e.preventDefault();
    save(recommender);
  };

  let pageOptions = [{ value: '', label: '' }];

  if (pages) {
    pageOptions = [
      { value: '', label: '' },
      ...pages.map((page) => ({
        value: page.id.toString(),
        label: page.name,
      })),
    ];
  }

  return (
    <Modal opened={show} onClose={() => close()} title="Copy Product Block">
      <form onSubmit={(e) => submitForm(e)}>
        <Grid>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Text size="sm" fw={500}>
              Page
            </Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <NativeSelect
              name="pageId"
              data={pageOptions}
              value={recommender.pageId || ''}
              onChange={({ target }) => setRecommender({ ...recommender, pageId: target.value })}
            />
          </Grid.Col>
        </Grid>
        <Group justify="flex-end" gap="xs" py="md">
          <Button variant="default" onClick={() => close()}>
            Close
          </Button>
          <Button type="submit" disabled={!recommender.pageId}>
            Make a copy
          </Button>
        </Group>
      </form>
    </Modal>
  );
};

export default RecommenderCopyModal;
